import { TransportOrderState } from "../transport/transportOrder";

interface IHubMessage {
    type: string;
}

export enum WorkShiftTimeSlotEvent {
    VehicleDriving = "VehicleDriving",
    VehicleDriverUpdated = "VehicleDriverUpdated",
    VehicleInactive = "VehicleInactive",
}

interface WorkShiftTimeSlotStartedMessage extends IHubMessage {
    type: "WorkShiftTimeSlotStarted";
    event: WorkShiftTimeSlotEvent;
    workTimeTypeName: string;
}

interface WorkShiftTimeSlotFinishedMessage extends IHubMessage {
    type: "WorkShiftTimeSlotFinished";
    event: WorkShiftTimeSlotEvent;
}

interface VehicleStoppedMessage extends IHubMessage {
    type: "VehicleStopped";
}

interface VehicleMovingMessage extends IHubMessage {
    type: "VehicleMoving";
}

export interface TransportOrderNotificationMessage extends IHubMessage {
    type: "TransportOrderNotification";
    transportOrderId: string;
    orderNumber: string;
    message: string;
    state: TransportOrderState;
    vehicleId: string;
}

export type HubMessage =
    | WorkShiftTimeSlotStartedMessage
    | WorkShiftTimeSlotFinishedMessage
    | VehicleStoppedMessage
    | VehicleMovingMessage
    | TransportOrderNotificationMessage;
